import { combineReducers } from '@reduxjs/toolkit'

import AudienceTypeReducer from './CandidatesAudienceTypeSlice'
import TimePeriodReducer from './CandidatesTimePeriodSlice'
import CandidatesContractReducer from './CandidatesContractSlice'

const appReducer = combineReducers({
  audienceType: AudienceTypeReducer,
  timePeriod: TimePeriodReducer,
  candidatesContract: CandidatesContractReducer
})

export const candidatesFilterReducer = (state, action) => {
  if (action.type === 'candidatesFilesFilter/reset') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}
